/** @jsx jsx */
import React, { useCallback } from 'react';
import { DocumentsList, DocumentViewer, HighlightWorkspaceTerms, formatDate } from 'slykit';
import { AnchorButton, Tag, Intent, Tooltip } from '@blueprintjs/core';
import * as ellipsize from 'ellipsize';
import { css, jsx } from '@emotion/react';
import * as d3 from 'd3';

const scoreScale = d3
	.scaleLinear()
	.domain([0, 0.5, 1])
	.range(['red', 'yellow', 'green']);

/**
 *
 * @returns {*}
 * @constructor
 */
export const PlatipusList = () => {
	const properties = ['Title', 'Published', 'Journal', 'Link', 'Abstract'];

	const Row = useCallback(({ item, onSelect }) => {
		const { Title, Published, Journal, Abstract } = item;

		return (
			<React.Fragment>
				<div css={titleStyle} title={Title}>
					<HighlightWorkspaceTerms text={ellipsize(Title, 120)} noTextMessage={'No Title'} />
				</div>
				<div css={textStyle}>
					<HighlightWorkspaceTerms text={ellipsize(Abstract, 220)} />
				</div>
				<div css={detailsStyle} className={'bp3-text-small bp3-text-muted'}>
					<div css={published}>
						<span
							css={css`
								padding-right: 12px;
							`}
						>
							{formatDate(Published)}
						</span>
						<span css={journal}>{Journal}</span>
					</div>
					<span style={{ flex: '1' }} />
					<AnchorButton
						minimal
						small
						intent={Intent.PRIMARY}
						rightIcon={'arrow-right'}
						text={'Preview'}
						onClick={onSelect}
					/>
				</div>
			</React.Fragment>
		);
	}, []);

	const SubTitle = useCallback(({ item }) => {
		const { Published, Journal } = item.propertyValues ?? {};
		const published = formatDate(Published);
		return (
			<React.Fragment>
				Published {published} in {Journal}
			</React.Fragment>
		);
	}, []);

	return (
		<React.Fragment>
			<DocumentsList
				propertyList={properties}
				sortPropertyName={'Published'}
				sortDescending={'true'}
				heading={'Publications'}
				rowRenderer={Row}
				linkProperty={'Link'}
				select
			/>
			<DocumentViewer
				titleProperty={'Title'}
				linkProperty={'Link'}
				subTitleRenderer={SubTitle}
				bodyProperties={[
					'Organization',
					'Categories',
					'Chemicals',
					'Countermeasures',
					'Species',
					'Disease',
					'Diagnostics/Analysis',
					'Context',
					'Type',
					'DOI',
					'Tags',
					'Abstract',
					'Authors',
					// 'Journal',
					// 'Published',
					// 'Link',
					// 'Title',
				]}
				hideEmptyValues
			/>
		</React.Fragment>
	);
};

const small = css`
	flex: 0 0 auto;
`;

const published = css`
	display: inline-flex;
	align-items: center;
	overflow: hidden;
`;

const journal = css`
	font-style: italic;
	min-width: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

const titleStyle = css`
	${small};
	font-size: 14px;
	font-weight: bold;
	/* overflow: hidden; */
	/* text-overflow: ellipsis; */
	/* display: flex; */
	padding-bottom: 6px;

	span {
		/* white-space: nowrap !important; */
		/* text-overflow: ellipsis; */
		/* min-width: 0; */
		/* overflow: hidden; */
	}
`;

const textStyle = css`
	${small};
	font-size: 12px;
	font-weight: lighter;
`;

const detailsStyle = css`
	${small};
	display: flex;
	flex-direction: row;
`;
